<template>
    <div v-if="isLoading" class="loading-overlay">
        <div class="loading-spinner"></div>
    </div>
</template>
  
  <script>
export default {
    data() {
        return {
            isLoading: false
        };
    },
    methods: {
        show() {
            this.isLoading = true;
        },
        hide() {
            this.isLoading = false;
        }
    }
};
</script>
  
  <style scoped>
.loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}

.loading-spinner {
    border: 2px solid #f3f3f3;
    border-top: 2px solid #3498db;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    animation: spin 2s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>